import { objectDestructuringEmpty as _objectDestructuringEmpty } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate } from "gyron";
import { h as _h } from "gyron";
import { Link, useRouter } from '@gyron/router';
import { FC, useMemo } from 'gyron';
import { Lang } from './translate';
import { $t, resolveTranslate } from '@/langs';
export const Mismatch = FC(({}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props = props;
    _objectDestructuringEmpty(_props);
  })
  const router = useRouter();
  const lang = useMemo(() => {
    return router.path.startsWith('/en-US') ? Lang.EN : Lang.ZH;
  });
  return ({}) => _h("div", {
    "class": "flex flex-auto items-center justify-center text-center px-4 flex-col sm:flex-row h-[calc(100vh-58px)]"
  }, [_h("h1", {
    "class": "text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight sm:pr-6 sm:mr-6 sm:border-r sm:border-slate-900/10 sm:dark:border-slate-300/10 dark:text-slate-200"
  }, "\n        404\n      "), _h("h2", {
    "class": "mt-2 text-lg text-slate-700 dark:text-slate-400 sm:mt-0"
  }, [$t('JSXText_13_74_15_8', lang.value), _h(Link, {
    "to": resolveTranslate('/', lang.value),
    "replace": true,
    "className": "underline"
  }, $t('JSXText_15_51_17_8', lang.value))])]);
});